import { render } from "./IconOrdersFilled.vue?vue&type=template&id=7ca0722e"
import script from "./IconOrdersFilled.vue?vue&type=script&lang=js"
export * from "./IconOrdersFilled.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__